module.exports = __webpack_public_path__ + "static/media/icon_arrow-down_red.a2e73f35.svg";